<footer class="bottom-nav">
  <ul class="nav justify-content-around w-100 m-0">
    <li class="nav-item">
      <a class="nav-link d-flex flex-column align-items-center" routerLink="/home" routerLinkActive="active">
        <img
          [alt]="'home_icon'"
          [src]="'assets/icons/home_icon_bottom_nav.svg'"
          class="home-access-icon"
        />
        <p class="m-0">Inicio</p>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link d-flex flex-column align-items-center" routerLink="/noticias" routerLinkActive="active">
        <img
          [alt]="'news_icon'"
          [src]="'assets/icons/news_icon_bottom_nav.svg'"
          class="home-access-icon"
        />
        <p class="m-0">Noticias</p>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link d-flex flex-column align-items-center" (click)="onNotificationClick()">
        <img
          [alt]="'notifications_icon'"
          [src]="'assets/icons/notifications_icon_bottom_nav.svg'"
          class="home-access-icon"
        />
        <p class="m-0">Notificaciones</p>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link d-flex flex-column align-items-center" routerLink="/personas" routerLinkActive="active">
        <img
          [alt]="'person_icon'"
          [src]="'assets/icons/people_icon_bottom_nav.svg'"
          class="home-access-icon"
        />
        <p class="m-0">Personas</p>
      </a>
    </li>
  </ul>
</footer>
